import type React from 'react'
import { useState } from 'react'
import { RichTextEditor } from '~/shared/ui/rich-text-editor'
import { FormField } from './form-field'

interface FormRichTextProps {
  // biome-ignore lint/suspicious/noExplicitAny: TanStack Form field API is dynamically typed
  field: any
  label: string
  placeholder?: string
  optional?: boolean
  labelAction?: React.ReactNode
}

export function FormRichText({
  field,
  label,
  placeholder,
  optional,
  labelAction,
}: FormRichTextProps) {
  const [hasBlurred, setHasBlurred] = useState(false)

  return (
    <FormField
      field={field}
      label={label}
      optional={optional}
      hasBlurred={hasBlurred}
      labelAction={labelAction}
    >
      <RichTextEditor
        id={field.name}
        value={field.state.value || ''}
        onChange={(html) => field.handleChange(html)}
        onBlur={() => {
          setHasBlurred(true)
          field.handleBlur()
        }}
        placeholder={placeholder}
        ariaLabel={label}
      />
    </FormField>
  )
}
